/* FB Cart Boot v8 - sepet drawer + sticky editorial + arama + carousel. */

function fbDebounce(fn, wait) {
  var t = null;
  return function () {
    if (t) return;
    t = setTimeout(function () { t = null; try { fn(); } catch (e) {} }, wait || 300);
  };
}

(function () {
  var __fbCartScroll = 0, __fbCartCloseUntil = 0, __fbUserScrolledClose = false, __fbYieldArmed = false;
  /* FB: kullanici sepet kapandiktan sonra kaydirmaya baslayinca scroll-geri-yuklemeyi BIRAK (titreme/kaydiramama fix) */
  function fbMarkUserScroll(e) { if (e && e.type === 'keydown') { var k = e.key; if (!(k === 'ArrowDown' || k === 'ArrowUp' || k === 'PageDown' || k === 'PageUp' || k === ' ' || k === 'Spacebar' || k === 'Home' || k === 'End')) return; } __fbUserScrolledClose = true; }
  function fbArmYield() { if (__fbYieldArmed) return; __fbYieldArmed = true; try { window.addEventListener('wheel', fbMarkUserScroll, { passive: true }); window.addEventListener('touchmove', fbMarkUserScroll, { passive: true }); window.addEventListener('keydown', fbMarkUserScroll, { passive: true }); } catch (e) {} }
  function fbDisarmYield() { if (!__fbYieldArmed) return; __fbYieldArmed = false; try { window.removeEventListener('wheel', fbMarkUserScroll); window.removeEventListener('touchmove', fbMarkUserScroll); window.removeEventListener('keydown', fbMarkUserScroll); } catch (e) {} }
  function fire() { try { document.dispatchEvent(new CustomEvent('fb:cart-drawer-render-fixed')); } catch (e) {} }
  function nudge(el) {
    if (!el || !el.style) return;
    var prev = el.style.opacity;
    el.style.opacity = '0.999';
    try { void el.offsetHeight; } catch (e) {}
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.style.opacity = prev || ''; }); });
  }
  var REPAINT_SEL = ['cart-drawer-component dialog .cart-drawer__summary','cart-drawer-component dialog .cart__ctas','cart-drawer-component dialog .cart__checkout-button','cart-drawer-component dialog [data-fb-kof]','.header-actions__cart-icon .cart-bubble'].join(', ');
  function repaint() { try { var nodes = document.querySelectorAll(REPAINT_SEL); for (var i = 0; i < nodes.length; i++) nudge(nodes[i]); } catch (e) {} }
  function hasItems(dlg) { return !!dlg.querySelector('.cart-form, .cart-items__table-row[data-key], [ref="cartItemRows[]"]'); }
  function checkoutVisible(dlg) { var btn = dlg.querySelector('.cart__checkout-button, button[name="checkout"]'); return !!(btn && btn.offsetParent !== null); }
  function retrigger(comp) { try { comp.dispatchEvent(new CustomEvent('dialog:open')); } catch (e) {} }
  function captureScroll() { try { var t = parseInt(document.body.style.top || '0', 10); __fbCartScroll = (t < 0) ? -t : (window.scrollY || window.pageYOffset || 0); if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {} }
  function restoreNow() { if (__fbUserScrolledClose) return; var sc = __fbCartScroll; if (sc > 0) { try { window.scrollTo(0, sc); } catch (e) {} } }
  function onOpen(dlg) {
    captureScroll(); fire(); repaint();
    var comp = (dlg.closest && dlg.closest('cart-drawer-component')) || null;
    if (comp) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (!dlg.hasAttribute('open')) { clearInterval(iv); return; }
        if (checkoutVisible(dlg)) { fire(); clearInterval(iv); return; }
        if (hasItems(dlg)) { retrigger(comp); fire(); }
        if (tries >= 6) clearInterval(iv);
      }, 700);
    }
    setTimeout(fire, 120); setTimeout(fire, 320);
  }
  /* FB v8: restoreNow() KALDIRILDI. dialog.js kapanis task'inde scroll'u zaten dogru konuma getiriyor. */
  function onClose(dlg) { __fbUserScrolledClose = false; __fbCartCloseUntil = 0; fbDisarmYield(); }
  document.addEventListener('fb:cart-drawer-render-fixed', function () { repaint(); });
  function watch() {
    var dialogs = document.querySelectorAll('cart-drawer-component dialog');
    for (var i = 0; i < dialogs.length; i++) {
      var dlg = dialogs[i];
      if (dlg.__fbBootWatch) continue;
      dlg.__fbBootWatch = true;
      (function (d) {
        try { var mo = new MutationObserver(function () { if (d.hasAttribute('open')) { onOpen(d); } else { onClose(d); } }); mo.observe(d, { attributes: true, attributeFilter: ['open'] }); } catch (e) {}
        if (d.hasAttribute('open')) onOpen(d);
      })(dlg);
    }
  }
  function watchBodyUnlock() {
    try {
      var ob = new MutationObserver(function () {
        if (Date.now() < __fbCartCloseUntil) { restoreNow(); }
      });
      ob.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
      ob.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
    } catch (e) {}
  }
  function editorialBg() {
    try {
      var stages = document.querySelectorAll('.fifty-sticky-editorial__stage');
      for (var i = 0; i < stages.length; i++) {
        (function (stage) {
          if (stage.querySelector('.fb-editorial-bg')) return;
          var img = stage.querySelector('.fifty-sticky-editorial__image--mobile') || stage.querySelector('.fifty-sticky-editorial__image--desktop') || stage.querySelector('.fifty-sticky-editorial__image');
          if (!img) return;
          function apply() {
            if (stage.querySelector('.fb-editorial-bg')) return;
            var src = img.getAttribute('src') || img.currentSrc || img.src;
            if (!src) return;
            var bg = document.createElement('div'); bg.className = 'fb-editorial-bg'; bg.setAttribute('aria-hidden', 'true'); bg.style.backgroundImage = 'url("' + src + '")';
            /* FB FLASH FIX (2026-06-11): bg sonradan PAT diye belirip yaziya "yerine oturma" hissi veriyordu -> yumusak gecis */
            bg.style.opacity = '0'; bg.style.transition = 'opacity .35s ease';
            stage.insertBefore(bg, stage.firstChild);
            requestAnimationFrame(function () { requestAnimationFrame(function () { bg.style.opacity = '1'; }); });
          }
          apply();
          if (img && !img.complete) { try { img.addEventListener('load', apply, { once: true }); } catch (e) {} }
        })(stages[i]);
      }
    } catch (e) {}
  }
  function boot() {
    watch(); editorialBg(); watchBodyUnlock();
    var deb = fbDebounce(function () { watch(); editorialBg(); }, 350);
    try { new MutationObserver(deb).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
    /* FB TIKLAMA HIZI FIX (2026-06-11): 'cart-drawer-component' seciciden CIKARILDI. */
    document.addEventListener('click', function (e) { var t = e.target && e.target.closest && e.target.closest('a[href*="/cart"], .header-actions__cart-icon, [data-cart-toggle]'); if (t) { setTimeout(fire, 60); setTimeout(fire, 260); } }, true);
    window.addEventListener('load', editorialBg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* === FB SEPET RENK/BEDEN ON-ISITMA (fb-login-gate.liquid'den tasindi, 2026-06-12) ===
   Urun verisini onceden ceker -> sepet acilinca Renk/Beden bilgisi ANINDA gorunur.
   (Login gate kaldirildi; bu hiz ozelligi korunarak buraya alindi.) */
(function () {
  if (window.__fbCartWarm) return; window.__fbCartWarm = 1;
  function warm(h) { if (!h) return; try { fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).catch(function () {}); } catch (e) {} }
  try { var pm = location.pathname.match(/\/products\/([^\/?#]+)/); if (pm) warm(decodeURIComponent(pm[1])); } catch (e) {}
  function warmCart() { try { fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { (c.items || []).forEach(function (it) { warm(it.handle); }); }).catch(function () {}); } catch (e) {} }
  if (document.readyState === 'complete') warmCart(); else window.addEventListener('load', warmCart);
})();

/* === FB VIDEO LAZY v2 === */
(function fbLazyVideos() {
  var deferred = [];
  function restore(v) {
    try {
      var ss = v.querySelectorAll('source[data-fb-src]');
      for (var m = 0; m < ss.length; m++) { ss[m].setAttribute('src', ss[m].getAttribute('data-fb-src')); ss[m].removeAttribute('data-fb-src'); }
      if (v.getAttribute('data-fb-src')) { v.setAttribute('src', v.getAttribute('data-fb-src')); v.removeAttribute('data-fb-src'); }
      v.setAttribute('preload', 'auto'); try { v.load(); } catch (e) {}
      if (v.autoplay) { try { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    } catch (e) {}
  }
  function restoreAll() { for (var i = 0; i < deferred.length; i++) restore(deferred[i]); deferred = []; }
  function initLazy() {
    try {
      var vids = document.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i]; var r = v.getBoundingClientRect(); var topAbs = r.top + (window.scrollY || window.pageYOffset || 0);
        if (topAbs < (window.innerHeight + 300)) continue;
        var stashed = false; var srcs = v.querySelectorAll('source');
        for (var j = 0; j < srcs.length; j++) { var sv = srcs[j].getAttribute('src'); if (sv) { srcs[j].setAttribute('data-fb-src', sv); srcs[j].removeAttribute('src'); stashed = true; } }
        var vsrc = v.getAttribute('src'); if (vsrc) { v.setAttribute('data-fb-src', vsrc); v.removeAttribute('src'); stashed = true; }
        if (!stashed) continue;
        v.setAttribute('preload', 'none'); try { v.load(); } catch (e) {} deferred.push(v);
      }
      if (!deferred.length) return;
      var io = new IntersectionObserver(function (entries) { for (var k = 0; k < entries.length; k++) { if (!entries[k].isIntersecting) continue; io.unobserve(entries[k].target); restore(entries[k].target); } }, { rootMargin: '1200px 0px' });
      for (var n = 0; n < deferred.length; n++) io.observe(deferred[n]);
      function bg() { setTimeout(function () { try { io.disconnect(); } catch (e) {} restoreAll(); }, 1500); }
      if (document.readyState === 'complete') bg(); else window.addEventListener('load', bg, { once: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLazy, { once: true }); else initLazy();
})();

/* === FB VIDEO PLAY-ON-VIEW v1 === ekran disindaki videolar sen yaklasinca (head-start) sessizce oynar; varinca oynuyor, bosluk yok. */
(function fbVideoPlayOnView() {
  if (!('IntersectionObserver' in window)) return;
  function playVid(v) {
    try {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }

  /* === FB RESUME GUARD (2026-06-12) ===
     Gorunurdeki SESSIZ AUTOPLAY LOOP video herhangi bir nedenle durdurulursa kendiliginden devam eder.
     Yalnizca autoplay + sessiz + KONTROLSUZ videolar; polling yok, play() reddi sessizce birakilir. */
  function fbInView(v) {
    try { var r = v.getBoundingClientRect(); return r.bottom > -100 && r.top < (window.innerHeight + 100) && r.width > 0; } catch (e) { return false; }
  }
  document.addEventListener('pause', function (e) {
    try {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO') return;
      if (!v.hasAttribute('autoplay') || v.controls) return;
      if (!(v.muted || v.hasAttribute('muted'))) return;
      if (v.ended || document.hidden || !v.isConnected) return;
      if (v.__fbResumeT) clearTimeout(v.__fbResumeT);
      v.__fbResumeT = setTimeout(function () {
        v.__fbResumeT = null;
        try {
          if (!v.paused || !v.isConnected || document.hidden) return;
          if (!fbInView(v)) return;
          playVid(v);
        } catch (e2) {}
      }, 120);
    } catch (err) {}
  }, true);

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) playVid(entries[i].target);
    }
  }, { rootMargin: '600px 0px 600px 0px', threshold: 0.01 });
  function scan() {
    try {
      var vids = document.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (v.__fbPlayView) continue;
        v.__fbPlayView = true;
        io.observe(v);
      }
    } catch (e) {}
  }
  function boot() {
    scan();
    setTimeout(scan, 800); setTimeout(scan, 2000); setTimeout(scan, 4000);
    try { new MutationObserver(fbDebounce(scan, 400)).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* === FB SEARCH ENHANCE v3 === */
(function fbSearchEnhance() {
  var TERMS = ['Elbise', 'Ceket', 'Bluz', 'Hırka', 'Takım', 'Triko', 'Gömlek', 'Kolye'];
  function fillSearch(input, t) {
    if (!input) return;
    try { var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set; setter.call(input, t); } catch (e) { input.value = t; }
    try { input.focus(); } catch (e) {}
    try { input.dispatchEvent(new InputEvent('input', { bubbles: true, data: t, inputType: 'insertText' })); } catch (e) { try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (e2) {} }
  }
  function injectChips(dlg) {
    try {
      var form = dlg.querySelector('.predictive-search-form');
      if (!form || form.querySelector('.fb-search-chips')) return;
      var anchor = form.querySelector('.predictive-search-form__content-wrapper');
      var input = dlg.querySelector('#cmdk-input') || dlg.querySelector('.search-input');
      var box = document.createElement('div'); box.className = 'fb-search-chips';
      var eb = document.createElement('span'); eb.className = 'fb-search-chips-eyebrow'; eb.textContent = 'POPÜLER ARAMALAR'; box.appendChild(eb);
      TERMS.forEach(function (t) { var c = document.createElement('button'); c.type = 'button'; c.className = 'fb-search-chip'; c.textContent = t; c.addEventListener('click', function () { fillSearch(input, t); }); box.appendChild(c); });
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor); else form.appendChild(box);
    } catch (e) {}
  }
  function bind(dlg) {
    if (dlg.__fbSearchWatch) return; dlg.__fbSearchWatch = true;
    function onState() {
      if (dlg.hasAttribute('open')) { document.documentElement.classList.add('fb-search-open'); injectChips(dlg); try { document.dispatchEvent(new CustomEvent('fb:search-open')); } catch (e) {} }
      else { document.documentElement.classList.remove('fb-search-open'); }
    }
    try { new MutationObserver(onState).observe(dlg, { attributes: true, attributeFilter: ['open'] }); } catch (e) {}
    onState();
  }
  function scan() { var dlg = document.querySelector('dialog.search-modal__content'); if (dlg) bind(dlg); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  try { new MutationObserver(fbDebounce(scan, 300)).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();

/* === FB PRODUCTS CAROUSEL v3 (PC >=750px) === */
(function fbProductsCarousel() {
  function injectStyle() {
    if (document.getElementById('fb-prod-style')) return;
    var st = document.createElement('style'); st.id = 'fb-prod-style';
    st.textContent = '@media (min-width:750px){'
      + 'dialog.search-modal__content .fb-prod-scroll{display:flex !important;grid-template-columns:none !important;overflow-x:auto !important;overscroll-behavior-x:contain !important;gap:16px !important;padding-bottom:6px !important;scrollbar-width:none !important;}'
      + 'dialog.search-modal__content .fb-prod-scroll::-webkit-scrollbar{display:none !important;}'
      + 'dialog.search-modal__content .fb-prod-scroll>li{flex:0 0 auto !important;width:158px !important;margin:0 !important;content-visibility:auto !important;contain-intrinsic-size:158px 270px !important;}'
      + 'dialog.search-modal__content .fb-prod-wrap{position:relative !important;}'
      + 'dialog.search-modal__content .fb-prod-arrow{position:absolute;top:33%;transform:translateY(-50%);z-index:6;width:34px;height:34px;border-radius:50%;background:#3a2c1e;border:1px solid rgba(61,46,31,.4);color:#f3e8d8;font-size:17px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 5px 14px -5px rgba(28,18,8,.5);transition:background .15s,color .15s,opacity .2s;font-family:Arial,sans-serif;padding:0;}'
      + 'dialog.search-modal__content .fb-prod-arrow:hover{background:#2e2218;color:#f3e8d8;}'
      + 'dialog.search-modal__content .fb-prod-arrow--prev{left:-2px;}'
      + 'dialog.search-modal__content .fb-prod-arrow--next{right:-2px;}'
      + 'dialog.search-modal__content .fb-prod-arrow[disabled]{opacity:0;pointer-events:none;}'
      + '}';
    (document.head || document.documentElement).appendChild(st);
  }
  var updFns = [];
  function setup() {
    var dlg = document.querySelector('dialog.search-modal__content'); if (!dlg) return; injectStyle(); if (window.innerWidth < 750) return;
    var grids = dlg.querySelectorAll('.predictive-search-results__products > .predictive-search-results__wrapper-products:not(.fb-prod-scroll)');
    for (var i = 0; i < grids.length; i++) {
      (function (grid) {
        try {
          grid.classList.add('fb-prod-scroll');
          var wrap = document.createElement('div'); wrap.className = 'fb-prod-wrap'; grid.parentNode.insertBefore(wrap, grid); wrap.appendChild(grid);
          var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'fb-prod-arrow fb-prod-arrow--prev'; prev.setAttribute('aria-label', 'Onceki urunler'); prev.textContent = '‹';
          var next = document.createElement('button'); next.type = 'button'; next.className = 'fb-prod-arrow fb-prod-arrow--next'; next.setAttribute('aria-label', 'Sonraki urunler'); next.textContent = '›';
          wrap.appendChild(prev); wrap.appendChild(next);
          function step() { return Math.max(grid.clientWidth * 0.85, 330); }
          prev.addEventListener('click', function () { try { grid.scrollBy({ left: -step(), behavior: 'smooth' }); } catch (e) { grid.scrollLeft -= step(); } });
          next.addEventListener('click', function () { try { grid.scrollBy({ left: step(), behavior: 'smooth' }); } catch (e) { grid.scrollLeft += step(); } });
          function upd() { if (grid.clientWidth < 10) return; var max = grid.scrollWidth - grid.clientWidth; if (max <= 8) { prev.disabled = true; next.disabled = true; return; } prev.disabled = (grid.scrollLeft <= 4); next.disabled = (grid.scrollLeft >= max - 4); }
          updFns.push(upd);
          grid.addEventListener('scroll', upd, { passive: true });
          try { new ResizeObserver(function () { upd(); }).observe(grid); } catch (e) {}
          try { new MutationObserver(function () { upd(); }).observe(grid, { childList: true }); } catch (e) {}
          setTimeout(upd, 60); setTimeout(upd, 400); setTimeout(upd, 900);
        } catch (e) {}
      })(grids[i]);
    }
  }
  function refreshAll() { for (var i = 0; i < updFns.length; i++) { try { updFns[i](); } catch (e) {} } }
  document.addEventListener('fb:search-open', function () { setup(); setTimeout(refreshAll, 80); setTimeout(refreshAll, 350); setTimeout(refreshAll, 800); });
  if (document.readyState !== 'loading') setup();
  document.addEventListener('DOMContentLoaded', setup);
  try { new MutationObserver(fbDebounce(setup, 350)).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();

/* === FB MOBIL URUN KARTI GORSEL SWAP KAPAT v2 (<750px) === */
(function fbMobileCardNoSwap() {
  if (window.innerWidth >= 750) return;
  function lock(img) {
    if (!img || img.__fbLock) return; img.__fbLock = true;
    try {
      var sAttr = img.getAttribute('src'); var ssAttr = img.getAttribute('srcset');
      var nativeSet = window.HTMLImageElement.prototype.setAttribute; var nativeRemove = window.HTMLImageElement.prototype.removeAttribute;
      img.setAttribute = function (n, v) { if (n === 'src' || n === 'srcset' || n === 'data-src' || n === 'data-srcset') return; return nativeSet.call(this, n, v); };
      img.removeAttribute = function (n) { if (n === 'src' || n === 'srcset') return; return nativeRemove.call(this, n); };
      try { Object.defineProperty(img, 'src', { configurable: true, get: function () { return sAttr; }, set: function () {} }); } catch (e) {}
      try { Object.defineProperty(img, 'srcset', { configurable: true, get: function () { return ssAttr || ''; }, set: function () {} }); } catch (e) {}
    } catch (e) {}
  }
  function clean() {
    try {
      var secs = document.querySelectorAll('.fps-card__img--secondary'); for (var i = 0; i < secs.length; i++) { if (secs[i] && secs[i].parentNode) secs[i].parentNode.removeChild(secs[i]); }
      var prims = document.querySelectorAll('.fps-card__img--primary'); for (var j = 0; j < prims.length; j++) lock(prims[j]);
    } catch (e) {}
  }
  clean();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean);
  window.addEventListener('load', clean);
  try { new MutationObserver(fbDebounce(clean, 250)).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();

/* === FB MOBIL ALT-MENU SATIR ANIMASYONU v7 (WAAPI) === */
(function fbSubmenuAnim() {
  var LI_SEL_SCOPE = ':scope > .menu-drawer__menu--childlist > li, :scope > .menu-drawer__menu--grandchildlist > li, :scope > .details-content > li, :scope > .details-content > .menu-drawer__menu--childlist > li, :scope > .details-content > .menu-drawer__menu--grandchildlist > li';
  var LI_SEL_FALLBACK = '.menu-drawer__menu--childlist > li, .menu-drawer__menu--grandchildlist > li, .details-content > li';
  var BOX_SEL = ':scope > .menu-drawer__menu--childlist, :scope > .menu-drawer__menu--grandchildlist, :scope > .details-content';
  var IN_DUR = 430, STAGGER = 42, EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  function smallScreen() { try { return !window.matchMedia || window.matchMedia('(max-width: 749px)').matches; } catch (e) { return true; } }
  function reduced() { try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function getLis(details) {
    var lis = null;
    try { lis = details.querySelectorAll(LI_SEL_SCOPE); } catch (e) { lis = null; }
    if (!lis || !lis.length) { try { lis = details.querySelectorAll(LI_SEL_FALLBACK); } catch (e2) { lis = null; } }
    return lis;
  }
  function getBox(details) {
    try { return details.querySelector(BOX_SEL); } catch (e) { return null; }
  }
  function animateIn(details) {
    if (!smallScreen() || reduced()) return;
    var lis = getLis(details);
    if (!lis || !lis.length || typeof lis[0].animate !== 'function') return;
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      if (li.__fbAnim) { try { li.__fbAnim.cancel(); } catch (e) {} }
      var delay = Math.min(i, 8) * STAGGER;
      try {
        li.__fbAnim = li.animate(
          [{ opacity: 0, transform: 'translateX(-16px)' }, { opacity: 1, transform: 'translateX(0)' }],
          { duration: IN_DUR, delay: delay, easing: EASE, fill: 'backwards' }
        );
        li.__fbAnim.onfinish = (function (el) { return function () { el.__fbAnim = null; }; })(li);
      } catch (e2) {}
    }
  }
  function closeWithAnim(details) {
    var box = getBox(details);
    if (!box || typeof box.animate !== 'function') { try { details.open = false; } catch (e) {} return; }
    var h = 0;
    try { h = box.getBoundingClientRect().height; } catch (e) {}
    if (!h) { try { details.open = false; } catch (e) {} return; }
    details.__fbClosing = true;
    var lis = getLis(details);
    if (lis && lis.length && typeof lis[0].animate === 'function') {
      var n = lis.length;
      for (var i = 0; i < n; i++) {
        var li = lis[i];
        if (li.__fbAnim) { try { li.__fbAnim.cancel(); } catch (e) {} }
        var delay = Math.min(n - 1 - i, 8) * STAGGER;
        try {
          li.__fbAnim = li.animate(
            [{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: 'translateX(-16px)' }],
            { duration: IN_DUR, delay: delay, easing: EASE, fill: 'forwards' }
          );
        } catch (e2) {}
      }
    }
    var prevOverflow = box.style.overflow;
    var prevWill = box.style.willChange;
    box.style.overflow = 'hidden';
    box.style.willChange = 'max-height';
    var anim;
    try {
      anim = box.animate(
        [{ maxHeight: h + 'px' }, { maxHeight: '0px' }],
        { duration: IN_DUR, easing: EASE, fill: 'forwards' }
      );
    } catch (e) { try { details.open = false; } catch (e2) {} details.__fbClosing = false; return; }
    var done = false;
    function finish() {
      if (done) return; done = true;
      try { details.open = false; } catch (e) {}
      try { anim.cancel(); } catch (e) {}
      box.style.overflow = prevOverflow || '';
      box.style.willChange = prevWill || '';
      box.style.maxHeight = '';
      if (lis) { for (var j = 0; j < lis.length; j++) { if (lis[j].__fbAnim) { try { lis[j].__fbAnim.cancel(); } catch (e) {} lis[j].__fbAnim = null; } } }
      details.__fbClosing = false;
    }
    anim.onfinish = finish;
    setTimeout(finish, IN_DUR + 120);
  }
  function onToggle(e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS') return;
    if (!(d.closest && d.closest('.menu-drawer'))) return;
    if (d.open) { requestAnimationFrame(function () { animateIn(d); }); }
  }
  function onClickCapture(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var summary = t.closest('accordion-custom summary');
      if (!summary) return;
      var details = summary.closest('details');
      if (!details || !(details.closest && details.closest('.menu-drawer'))) return;
      if (!details.open) return;
      if (details.__fbClosing) return;
      if (!smallScreen() || reduced()) return;
      var box = getBox(details);
      if (!box || typeof box.animate !== 'function') return;
      e.preventDefault();
      closeWithAnim(details);
    } catch (err) {}
  }
  function start() {
    document.addEventListener('toggle', onToggle, true);
    document.addEventListener('click', onClickCapture, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* === FB PC GALERI OKLARI (gorsel blogundan tasindi; artik buradan yonetilir) === */
(function fbGalleryArrows() {
  function isVisible(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 250 && rect.height > 250;
  }
  function findGallery() {
    var selectors = ['media-gallery', '.product-gallery', '.product__media-gallery', '.product-media-gallery', '.product-media', '.product__media', '.product-media-container', '[id*="MediaGallery"]', '[class*="media-gallery"]', '[class*="product-media"]'];
    for (var i = 0; i < selectors.length; i++) {
      var items = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < items.length; j++) {
        if (items[j].querySelector('img') && isVisible(items[j])) { return items[j]; }
      }
    }
    return null;
  }
  function findNativeButton(gallery, direction) {
    var prevSelectors = ['.slider-button--prev', 'button[name="previous"]', 'button[aria-label*="Previous"]', 'button[aria-label*="Önceki"]'];
    var nextSelectors = ['.slider-button--next', 'button[name="next"]', 'button[aria-label*="Next"]', 'button[aria-label*="Sonraki"]'];
    var selectors = direction === 'prev' ? prevSelectors : nextSelectors;
    for (var i = 0; i < selectors.length; i++) {
      var btn = gallery.querySelector(selectors[i]) || document.querySelector(selectors[i]);
      if (btn && !btn.classList.contains('fb-custom-gallery-arrow')) { return btn; }
    }
    return null;
  }
  function fallbackScroll(gallery, direction) {
    var scroller = gallery.querySelector('.slider') || gallery.querySelector('[class*="slider"]') || gallery.querySelector('[class*="carousel"]') || gallery.querySelector('[class*="media-list"]') || gallery;
    var amount = gallery.clientWidth * 0.85;
    scroller.scrollBy({ left: direction === 'next' ? amount : -amount, behavior: 'smooth' });
  }
  function createArrows() {
    if (window.innerWidth < 750) return;
    var gallery = findGallery();
    if (!gallery) return;
    if (gallery.querySelector('.fb-custom-gallery-arrow')) return;
    gallery.style.position = 'relative';
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'fb-custom-gallery-arrow fb-custom-gallery-arrow--prev';
    prev.innerHTML = '<span>‹</span>';
    prev.setAttribute('aria-label', 'Onceki gorsel');
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'fb-custom-gallery-arrow fb-custom-gallery-arrow--next';
    next.innerHTML = '<span>›</span>';
    next.setAttribute('aria-label', 'Sonraki gorsel');
    prev.addEventListener('click', function () { var b = findNativeButton(gallery, 'prev'); if (b) { b.click(); } else { fallbackScroll(gallery, 'prev'); } });
    next.addEventListener('click', function () { var b = findNativeButton(gallery, 'next'); if (b) { b.click(); } else { fallbackScroll(gallery, 'next'); } });
    gallery.appendChild(prev);
    gallery.appendChild(next);
  }
  document.addEventListener('DOMContentLoaded', function () { createArrows(); setTimeout(createArrows, 500); setTimeout(createArrows, 1200); });
  document.addEventListener('shopify:section:load', function () { setTimeout(createArrows, 300); });
})();